<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">ปิด</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <div class="row text-center mb-0" v-if="step === 1">
      <div class="col-12 mb-3">
        <h1>กรุณาใส่จำนวนเงิน</h1>
      </div>
      <div class="col-12">
        <div class="search-box search-header bg-theme card-style mb-0 m-0">
          <i class="fa fa-dollar"></i>
          <input type="number" class="border-0 font-25" autofocus placeholder="ระบุจำนวนเงิน" v-model="price">
        </div>
        <p class="text-danger text-center font-25 mt-2"> ต่ำสุด {{ prices[0] }} บาท | สูงสุด 200,000 บาท</p>
      </div>
      <div class="col-12" v-if="events.length > 0">
        <div class="divider mb-3"></div>
        <h1 class="mb-2">โปรโมชัน</h1>
        <div class="row">
          <div class="col-6" @click="price = event.condition" v-for="event in events" :key="event.id">
            <img :src="event.cover" class="rounded-2">
          </div>
        </div>
        <div class="divider"></div>
      </div>
<!--      <div class="col-3 p-0" v-for="(price,index) in prices" :key="index">-->
<!--        <div class="card card-style p-2 m-1" @click="pickPrice(price)">-->
<!--          <h1>{{ Number(price).toLocaleString() }}</h1>-->
<!--          <span class="text-success" v-if="events.some(item => item.condition === parseInt(price))">โบนัส {{-->
<!--              events.find(item => item.condition === parseInt(price)).condition_type === 1 ? Number((parseInt(price) * (events.find(item => item.condition === parseInt(price)).amount) / 100)).toLocaleString() : Number(events.find(item => item.condition === parseInt(price)).amount).toLocaleString()-->
<!--            }} บาท</span>-->
<!--          <span v-else>โบนัส 0 บาท</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col-12 mt-3">
        <button class="btn w-100 rounded-2 text-uppercase shadow-s bg-green-light" @click="checkout()">ชำระเงิน</button>
      </div>
    </div>
    <div class="row mb-0" v-else>
      <div class="col-12 text-center">
        <img :src="payment.slip" class="text-center mb-3" style="height: 20vh;"><br/>
        <div class="alert alert-warning mt-2">
          QR Code จะถูกสร้างใหม่บิลต่อบิล ไม่สามารถใช้ซ้ำได้ กรุณาอย่าบันทึกรูป QR แล้วใช้ซ้ำ
          เนื่องจากจะทำให้เกิดปัญหาด้านการตรวจสอบและทำให้คำสั่งซื้อถูกยกเลิก
        </div>
      </div>
      <div class="col-12">
        <div class="divider"></div>
        <h3 class="text-center mt-4">วิธีชำระเงินผ่าน QR Code</h3>
        <ul>
          <li>เปิด Bank Application</li>
          <li>เลือกสแกน QR Code</li>
          <li>นำกล้องมาสแกนที่ QR Code หรือบันทึกรูป QR Code</li>
          <li>ชำระเงินตามขั้นตอน และกดที่ "ชำระแล้ว" ด้านบนขวามือ</li>
          <li>รอระบบตรวจสอบประมาณ 1-2 นาที</li>
          <li class="text-danger">QR Code จะถูกสร้างใหม่บิลต่อบิล ไม่สามารถใช้ซ้ำได้ กรุณาอย่าบันทึกรูป QR แล้วใช้ซ้ำ
            เนื่องจากจะทำให้เกิดปัญหาด้านการตรวจสอบและทำให้คำสั่งซื้อถูกยกเลิก
          </li>
        </ul>
      </div>
    </div>
  </ion-content>
</template>

<script>
import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonToolbar,
  loadingController,
  modalController,
} from '@ionic/vue';
import {Clipboard} from "@capacitor/clipboard";

export default {
  name: 'WalletModal',
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonButtons,
    IonButton,
  },
  mounted() {
    this.getData();
  },
  unmounted() {
    clearInterval(this.loop);
  },
  data() {
    return {
      loading: '',
      bank: [],
      previewImage: require('@/assets/images/slip.png'),
      step: 1,
      prices: [],
      price: null,
      slip: '',
      payment: null,
      loop: null,
      events: []
    }
  },
  methods: {
    async send() {
      try {
        this.loading = await loadingController.create({
          message: 'โปรดรอสักครุ่',
          spinner: 'circles',
          mode: 'ios'
        })

        await this.loading.present();
        const response = await this.axios.post(`/deposit`, {
          amount: this.price,
          topup: 1
        });

        this.payment = response.data.result;

        await this.loading.dismiss();
        this.step = 2;
        await this.getData();
      } catch (error) {
        this.loading.dismiss();
        const alert = await alertController.create({
          header: 'ขออภัย',
          subHeader: error.response.data.message ?? "เกิดข้อผิดพลาดบางอย่าง กรุณาติดต่อฝ่ายบริการลูกค้า",
          buttons: ['ปิด'],
          mode: "ios"
        });

        await alert.present();
      }
    },
    async cancelOrder() {
      try {
        this.loading = await loadingController.create({
          message: 'โปรดรอสักครุ่',
          spinner: 'circles',
          mode: 'ios'
        })

        await this.loading.present();
        const response = await this.axios.delete(`/deposit/${this.payment.id}`);
        await this.loading.dismiss();
        const alert = await alertController.create({
          header: "สำเร็จ",
          subHeader: response.data.message,
          buttons: ['ตกลง'],
          mode: "ios"
        });

        await alert.present();
        await modalController.dismiss(null, 'success');
      } catch (error) {
        this.loading.dismiss();
        const alert = await alertController.create({
          header: 'ขออภัย',
          subHeader: error.response.data.message ?? "เกิดข้อผิดพลาดบางอย่าง กรุณาติดต่อฝ่ายบริการลูกค้า",
          buttons: ['ปิด'],
          mode: "ios"
        });

        await alert.present();
      }
    },
    async pickPrice(price) {
      this.price = price;
    },
    async copy(text) {
      try {
        await Clipboard.write({
          string: text
        });

        const alert = await alertController.create({
          header: 'คัดลอกบัญชีสำเร็จ',
          buttons: ['ตกลง'],
          mode: "ios"
        });

        await alert.present();
      } catch (e) {
        console.log(e)
      }
    },
    uploadImage(e) {
      const image = e.target.files[0];
      this.slip = image;
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.previewImage = e.target.result;
      };
    },
    async getData() {
      const response = await this.axios.get(`/deposit`);
      this.bank = response.data.result.bank;
      this.prices = response.data.result.prices;
      this.events = response.data.result.events;
      await this.checkOrder(response.data.result.waiting);
      if (response.data.result.waiting) {
        if (this.loop === null) {
          this.loop = setInterval(this.getData, 10000);
        }
        this.payment = response.data.result.waiting;
        this.step = 2;
      }
    },
    cancel() {
      return modalController.dismiss(null, 'cancel');
    },
    async confirm() {
      this.loading = await loadingController.create({
        message: 'กำลังตรวจสอบ อาจใช้เวลาประมาณ 1-2 นาที',
        spinner: 'circles',
        mode: 'ios'
      })

      await this.loading.present();

    },
    async checkout() {
      if (this.price === null) {
        const alert = await alertController.create({
          header: 'กรุณาระบุจำนวนเงินที่ต้องการ',
          subHeader: `จำนวนเงินต่ำสุด ${this.prices[0]} บาท สูงสุด 200,000 บาท`,
          buttons: ['ตกลง'],
          mode: "ios"
        });

        await alert.present();
      } else if (this.price < Number(this.prices[0]) || Number(this.price) > 200000) {
        const alert = await alertController.create({
          header: 'จำนวนเงินไม่ถูกต้อง',
          subHeader: `จำนวนเงินต่ำสุด ${this.prices[0]} บาท สูงสุด 200,000 บาท`,
          buttons: ['ตกลง'],
          mode: "ios"
        });

        await alert.present();
      } else {
        await this.send();
      }
    },
    async checkOrder(p) {
      if (this.payment && p === null) {
        clearInterval(this.loop);
        const alert = await alertController.create({
          header: "แจ้งเตือน",
          subHeader: "รายการของท่านได้รับการตรวจสอบแล้ว",
          buttons: ['ตกลง'],
          mode: "ios"
        });

        await alert.present();
        await modalController.dismiss(null, 'success');
      }
    }
  }
}
</script>
<style scoped>
ion-modal {
  --height: auto;
}

.search-box .fa-dollar {
  position: absolute;
  left: 0px;
  line-height: 52px;
  padding: 0px 15px 0px 15px;
}

.search-box input::placeholder {
  font-size: 20px !important;
}
</style>
